export default {
    WORKER_LIST: 'WORKER_LIST', //출근작업자 리스트
    CAR_LIST: 'CAR_LIST', //차량 리스트
    WORK_LIST: 'WORK_LIST', //작업지시 리스트
    MAP_BOUNDS: 'MAP_BOUNDS' //mapbox bounds
};
